import React from "react";
import { BackgroundSVG } from "./BackgroundSVG";

function GoogleIcon({ animate, transition }) {
  return (
    <BackgroundSVG
      top={"25%"}
      left={"10%"}
      animate={animate}
      transition={transition}
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.999 8.4904C21.4262 8.4904 23.6548 9.32147 25.4338 10.7036L30.8941 5.49373C27.7195 2.69491 23.5637 0.983379 18.999 0.983379C12.0819 0.983379 6.08334 4.88689 3.06453 10.6072L9.13621 15.401C10.607 11.3722 14.4615 8.49041 18.999 8.49041L18.999 8.4904Z"
        fill="#F5594E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.8601 21.2526C36.954 20.5143 37.0161 19.7611 37.0161 18.9971C37.0161 17.7087 36.8755 16.4541 36.6186 15.2424H18.9995V22.7518H28.7378C27.95 24.8 26.5473 26.5331 24.7619 27.7372L30.8567 32.5504C34.0875 29.7136 36.2985 25.7411 36.8601 21.2526V21.2526Z"
        fill="#39A0F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.48466 18.997C8.48466 17.7304 8.72001 16.5217 9.13017 15.3972L3.06207 10.6024C1.73955 13.1105 0.982884 15.9639 0.982884 18.997C0.982884 21.9962 1.72564 24.818 3.02069 27.3057L9.09648 22.5048C8.70737 21.4063 8.48466 20.229 8.48466 18.997V18.997Z"
        fill="#FFC721"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.9991 29.5085C14.4266 29.5085 10.547 26.5827 9.10174 22.5049L3.02185 27.3057C6.02614 33.0726 12.0475 37.0166 18.9991 37.0166C23.5449 37.0166 27.6902 35.3275 30.8561 32.5482L24.7614 27.7358C23.1147 28.8462 21.1437 29.5085 18.9991 29.5085V29.5085Z"
        fill="#00CA6F"
      />
      <path
        opacity="0.1"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.9962 36.6413C13.6936 36.6413 8.92574 34.4536 5.55479 30.9682C8.85463 34.6712 13.6458 37.0166 18.9962 37.0166C24.2971 37.0166 29.0485 34.7175 32.341 31.0725C28.98 34.5013 24.2483 36.6413 18.9962 36.6413Z"
        fill="white"
      />
      <path
        opacity="0.1"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.9995 22.3768V22.7577H28.74L28.8921 22.3768H18.9995Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.0095 19.2214C37.0105 19.1468 37.0166 19.0733 37.0166 18.9984C37.0166 18.9772 37.0138 18.9567 37.0137 18.9355C37.0129 19.031 37.0088 19.1255 37.0095 19.2214Z"
        fill="#262626"
      />
      <path
        opacity="0.2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.9995 15.2424V15.6232H36.6923C36.6686 15.4975 36.6428 15.3671 36.6167 15.2424H18.9995Z"
        fill="#0D0D0D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.6186 15.2465H18.9995V22.7535H28.7378C27.2233 26.6895 23.4694 29.5097 18.9995 29.5097C13.1952 29.5097 8.48981 24.8043 8.48981 19C8.48981 13.1956 13.1952 8.49031 18.9995 8.49031C21.1042 8.49031 23.0441 9.1369 24.6875 10.2029C24.9391 10.3664 25.1986 10.5199 25.4349 10.7035L30.8957 5.4937L30.7725 5.39894C27.6128 2.66054 23.5089 0.983389 18.9995 0.983389C9.04917 0.983389 0.982885 9.04967 0.982885 19C0.982885 28.9503 9.04917 37.0166 18.9995 37.0166C28.1845 37.0166 35.7482 30.1384 36.8601 21.2548C36.954 20.5167 37.0161 19.7638 37.0161 19C37.0161 17.7121 36.8755 16.4579 36.6186 15.2466V15.2465Z"
        fill="url(#paint0_linear_12_1076)"
      />
      <path
        opacity="0.1"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.6858 9.82854C23.0424 8.76256 21.1026 8.116 18.9978 8.116C13.1935 8.116 8.48809 12.8211 8.48809 18.6252C8.48809 18.6885 8.48894 18.738 8.49004 18.8012C8.59129 13.0846 13.2568 8.49133 18.9978 8.49133C21.1026 8.49133 23.0424 9.13789 24.6859 10.2039C24.9374 10.3673 25.1969 10.5208 25.4333 10.7044L30.894 5.49484L25.4333 10.329C25.1969 10.1455 24.9375 9.99201 24.6858 9.82854H24.6858Z"
        fill="white"
      />
      <path
        opacity="0.2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.9986 1.35868C23.465 1.35868 27.5304 3.00757 30.6777 5.69953L30.8941 5.4931L30.7289 5.34926C27.5695 2.61121 23.5077 0.983379 18.9986 0.983379C9.04875 0.983379 0.982895 9.04865 0.982895 18.9977C0.982895 19.061 0.991694 19.1222 0.992334 19.1854C1.09405 9.3238 9.11206 1.35868 18.9986 1.35868Z"
        fill="#0D0D0D"
      />
      <defs>
        <linearGradient
          id="paint0_linear_12_1076"
          x1="0.980005"
          y1="37.02"
          x2="37.02"
          y2="37.02"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.2" />
          <stop offset="1" stopColor="white" stopOpacity="0.01" />
        </linearGradient>
      </defs>
    </BackgroundSVG>
  );
}

function SlackIcon({ animate, transition }) {
  return (
    <BackgroundSVG
      top={"25%"}
      right={"0"}
      animate={animate}
      transition={transition}
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.3932 5.90757H32.7076C32.3888 5.90757 32.0682 5.94073 31.7549 6.00705L3.88395 11.9173C1.77575 12.3641 0.244368 14.2534 0.244368 16.4089C0.244368 18.9403 2.30466 21 4.8367 21H5.52225C5.84105 21 6.16171 20.9669 6.475 20.9006L34.3459 14.9903C36.4542 14.5436 37.9855 12.6542 37.9855 10.4987C37.9855 7.96731 35.9253 5.90757 33.3932 5.90757Z"
        fill="#89D3DE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.1614 21H36.4759C36.1571 21 35.8364 21.0332 35.5231 21.0995L7.65219 27.0096C5.54399 27.4565 4.01261 29.3458 4.01261 31.5013C4.01261 34.0327 6.0729 36.0925 8.60494 36.0925H9.29049C9.60929 36.0925 9.92995 36.0593 10.2432 35.993L38.1142 30.0827C40.2224 29.6359 41.7538 27.7467 41.7538 25.5911C41.7538 23.0597 39.6935 21 37.1614 21H37.1614Z"
        fill="#E4346B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.9921 31.7558L30.0819 3.88493C29.634 1.77582 27.7457 0.245346 25.5901 0.245346C23.0588 0.245346 20.999 2.30564 20.999 4.83768V5.52413C20.999 5.84754 21.0322 6.16912 21.0985 6.47595L27.0087 34.3469C27.4565 36.4561 29.3448 37.9865 31.5004 37.9865C34.0317 37.9865 36.0915 35.9262 36.0915 33.3942V32.7077C36.0915 32.3844 36.0583 32.0627 35.9921 31.7558V31.7558Z"
        fill="#EEBB43"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.8996 35.5239L14.9893 7.65304C14.5417 5.54393 12.6533 4.01345 10.4977 4.01345C7.96635 4.01345 5.9066 6.07375 5.9066 8.60579V9.29224C5.9066 9.61566 5.93976 9.93724 6.00607 10.2441L11.9163 38.115C12.364 40.2242 14.2524 41.7546 16.4079 41.7546C18.9393 41.7546 20.9991 39.6943 20.9991 37.1623V36.4758C20.9991 36.1525 20.9659 35.8308 20.8996 35.5239H20.8996Z"
        fill="#77C9AD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4154 35.7519L9.47832 26.62L18.6004 24.685L20.5375 33.817L11.4154 35.7519Z"
        fill="#E8CCE8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.619 32.521L24.6841 23.3987L33.8162 21.4618L35.7511 30.5841L26.619 32.521Z"
        fill="#DE353A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.18206 20.5387L6.247 11.4166L15.3789 9.47944L17.314 18.6016L8.18206 20.5387Z"
        fill="#2BA085"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.3971 17.3146L21.46 8.18269L30.5821 6.24763L32.5193 15.3796L23.3971 17.3146Z"
        fill="#92AE43"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6013 24.6895L17.3101 18.6017L23.3979 17.3105L24.6891 23.3983L18.6013 24.6895ZM37.1646 21H36.479C36.1602 21 35.8396 21.0332 35.5263 21.0995L33.8135 21.4628L32.5223 15.3751L34.3432 14.9888C36.4515 14.5419 37.9828 12.6521 37.9828 10.496C37.9828 7.96403 35.9225 5.90377 33.3905 5.90377H32.7049C32.3861 5.90377 32.0655 5.93694 31.7522 6.00328L30.5869 6.25044L30.0845 3.88222C29.6366 1.77313 27.7479 0.242676 25.5918 0.242676C23.0598 0.242676 20.9995 2.30294 20.9995 4.83494V5.52138C20.9995 5.84479 21.0327 6.16636 21.099 6.47319L21.4623 8.18596L15.3746 9.4772L14.9883 7.65627C14.5405 5.54719 12.6516 4.01674 10.4955 4.01674C7.96354 4.01674 5.90328 6.077 5.90328 8.609V9.29544C5.90328 9.61886 5.93645 9.94043 6.00278 10.2473L6.24994 11.4126L3.88172 11.915C1.77355 12.3619 0.242188 14.2517 0.242188 16.4077C0.242188 18.9397 2.30245 21 4.83445 21H5.51999C5.83879 21 6.15944 20.9668 6.47272 20.9005L8.18549 20.5372L9.47672 26.6249L7.6558 27.0112C5.54762 27.4582 4.01626 29.3478 4.01626 31.504C4.01626 34.036 6.07652 36.0962 8.60852 36.0962H9.29406C9.61286 36.0962 9.93351 36.0631 10.2468 35.9967L11.4121 35.7496L11.9145 38.1178C12.3623 40.2269 14.2512 41.7573 16.4073 41.7573C18.9393 41.7573 20.9995 39.6971 20.9995 37.1651V36.4786C20.9995 36.1552 20.9663 35.8336 20.9 35.5268L20.5367 33.814L26.6244 32.5228L27.0107 34.3437C27.4586 36.4529 29.3474 37.9833 31.5035 37.9833C34.0355 37.9833 36.0958 35.923 36.0958 33.391V32.7046C36.0958 32.3812 36.0626 32.0596 35.9963 31.7528L35.7491 30.5874L38.1173 30.085C40.2255 29.6381 41.7569 27.7484 41.7569 25.5923C41.7569 23.0603 39.6966 21 37.1646 21L37.1646 21Z"
        fill="url(#paint0_linear_12_1093)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_12_1093"
          x1="-7.14999"
          y1="31.25"
          x2="31.25"
          y2="49.15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.2" />
          <stop offset="1" stopColor="white" stopOpacity="0.01" />
        </linearGradient>
      </defs>
    </BackgroundSVG>
  );
}

function FacebookIcon({ animate, transition }) {
  return (
    <BackgroundSVG
      bottom={"0"}
      left={"10%"}
      animate={animate}
      transition={transition}
      width="20"
      height="39"
      viewBox="0 0 20 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.4192 13.387H12.1371V8.519C12.1371 7.1753 13.2244 6.08488 14.5647 6.08488H16.992V0H12.1371C8.11499 0 4.85504 3.26866 4.85504 7.30186V13.387H0V19.4718H4.85504V38.9436H12.1371V19.4718H16.992L19.4192 13.387Z"
        fill="#328CE7"
      />
    </BackgroundSVG>
  );
}

export { GoogleIcon, SlackIcon, FacebookIcon };
